import { Avatar, Tooltip } from '@mantine/core';

import dayjs from 'dayjs';

// import { ReactComponent as LockIcon } from 'assets/icons/lockIcongreen.svg';
import { ReactComponent as CalanderIcon } from 'assets/icons/calanderIcon.svg';
import { ReactComponent as TeamIcon } from 'assets/icons/teamIcon.svg';
// import { ReactComponent as FolderIcon } from 'assets/icons/folderIcon.svg';

const ModalFolderCards = ({
  folder,
  selectedId,
  setSelectedId,
  historyOfPath,
  setHistoryOfPath,
  setMainPath,
}) => {
  return (
    <>
      <div
        className={
          selectedId === folder?.id
            ? '  rounded-3xl shadow-three p-5 cursor-pointer border-[1px]  border-primary border-opacity-70'
            : 'rounded-3xl shadow-three p-5 cursor-pointer '
        }
        onClick={() => {
          setSelectedId(folder?.id);
          setHistoryOfPath(folder?.path);
          setMainPath(folder?.path);
        }}
      >
        <div className=' flex justify-between items-center '>
          {folder?.name.length >= 35 ? (
            <Tooltip
              label={folder?.name}
              classNames={{
                body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
              }}
              radius='md'
            >
              <h1 className='font-semibold text-[#333333] cursor-pointer truncate w-72'>
                {folder?.name}
              </h1>
            </Tooltip>
          ) : (
            <h1 className='font-semibold text-[#333333] cursor-pointer'>
              {folder?.name}
            </h1>
          )}
        </div>

        <div className='flex justify-between items-center'>
          <div className='py-8'>
            <p className='flex items-center gap-2 text-sm py-1 text-[#828282]'>
              <CalanderIcon />
              {dayjs(folder?.created_date).format('DD MMM YYYY, H:m')}
            </p>
            <p className='flex items-center gap-2 text-sm py-1 text-[#828282]'>
              <TeamIcon />{' '}
              {folder?.members.length === 1
                ? `${folder?.members.length} member`
                : `${folder?.members.length} membes`}{' '}
            </p>
          </div>

          <div
            className='flex '
            // onClick={() => {
            //   setSelectedRow(element);
            //   setTeamMemberPopoverOpened(true);
            // }}
          >
            {folder?.members.length === 0 ? null : (
              <Avatar
                src={folder?.members[0]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 border-2 border-primary border-opacity-50'
              >
                {folder?.members[0]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            )}
            {folder?.members?.length > 1 ? (
              <Avatar
                src={folder?.members[1]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 transform -translate-x-4 border-2 border-primary border-opacity-50'
              >
                {folder?.members[1]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            ) : null}
            {folder?.members?.length > 2 ? (
              <Avatar
                src={folder?.members[2]?.employee__profile_picture}
                color='#EEF3F1'
                radius='xl'
                classNames={{
                  placeholder: 'text-xl',
                }}
                className='w-12 h-12 transform -translate-x-8 border-2 border-primary border-opacity-50'
              >
                {folder?.members[2]?.employee__user__first_name?.substring(
                  0,
                  1
                )}
              </Avatar>
            ) : null}
            {folder?.members?.length > 3 ? (
              <span
                className='w-12 h-12 flex justify-center items-center rounded-full bg-primary transform -translate-x-12 text-white select-none border-2 border-primary border-opacity-50'
                // onClick={() => {
                //   setSelectedRow(element);
                //   setTeamMemberPopoverOpened(true);
                // }}
              >
                +{folder?.members?.length - 3}
              </span>
            ) : null}
          </div>
        </div>

        <div className='flex justify-between items-center'>
          <div className='flex gap-3'>
            <Avatar
              className='w-12 h-12 border-2 border-primary border-opacity-50'
              radius='xl'
              color='#FB7C51'
              src={folder?.created_by__user_employee__profile_picture}
              classNames={{
                placeholder: 'text-xl',
              }}
            >
              {folder?.created_by__first_name?.substring(0, 1)}
            </Avatar>
            <div className=''>
              <h1 className='text-[#707070]'>
                {folder?.created_by__first_name}
              </h1>
              <p className='text-[#969696] text-sm'>
                {folder?.created_by__user_employee__designation__name ||
                  'Admin'}
              </p>
            </div>
          </div>
          {/* <p className='flex gap-2 items-center text-[#969696]'>
            <FolderIcon /> 05(s)
          </p> */}
        </div>
      </div>
    </>
  );
};

export default ModalFolderCards;
